import moment from "moment";

const formatDateTrackingHistoryV2 = (date: any, timezone: any) => {
  const formattedDate = new Date(date);

  let utcOffset = "0";
  if (timezone) {
    let tz = timezone.replace("GMT", "");
    if (tz.length < 6 && (tz.startsWith("+") || tz.startsWith("-"))) {
      tz = tz.slice(0, 1) + "0" + tz.slice(1);
    }
    utcOffset = tz;
  }
  const newDate = moment(formattedDate)
    .utcOffset(utcOffset)
    .format("YYYY-MM-DD");
  return newDate;
};
export default formatDateTrackingHistoryV2;
